
const FacetedSearchLinkFieldInput = (props) => {

    const handleChange = (e) => {
        if (props.SegmentOverhaul) {
            props.OpenShowAllModal(props.SegmentValue);
        } else {
            props.CheckboxChange(e);
        }
    }

    return (
        <div key={props.Name} className={'faceted-link faceted-option-checkbox-container ' + (props.AdditionalClassName ? props.AdditionalClassName : props.MustBeSelectedIndividually ? 'individual-option visible' : '')} >
            <label htmlFor={props.Value} style={{ paddingLeft: props.Indent * 10 + 'px', fontWeight: props.IsGroup ? 'bold' : 'normal' }}>
                <input type='checkbox' id={props.Value} name={props.FieldName} value={props.Value}
                    onChange={handleChange} checked={props.Checked}/>
                <span className='option-name' >
                    <div className='view-text' tabindex="0" onKeyDown={props.OnKeyDown}>
                        {props.Checked ? props.DisplayNamePlusHide : props.DisplayNamePlusView}
                    </div>
                </span>
                {props.ShowCounts && <span className='option-count'>({props.Count})</span>}
            </label>
        </div>
    );
};

export default FacetedSearchLinkFieldInput;